import rangy from '@yola/rangy';
import '@yola/rangy/lib/rangy-textrange';
import view from '../../view';
import instance from '../../hdrm/instance';
import preserveTextElement from '../../hdrm/utils/helpers/preserve-text-element';
import wrapperMap from '../helpers/wrapper-map';

const findAndApplyWrapper = (searchTerm, wrapperId, elementId, searchOptions = {}) => {
  const wrapper = wrapperMap.getWrapperById(wrapperId);
  if (!wrapper) throw new Error('wrapper with specified id does not exist');

  const range = rangy.createRange();
  const targetElement = view.accessors.getLiveElement(elementId);
  range.selectNodeContents(targetElement);

  instance.driver.removeAllTextInjections(targetElement);

  while (range.findText(searchTerm, searchOptions)) {
    wrapper.applyToRange(range);
    range.collapse(false);
  }

  preserveTextElement(targetElement);
};

export default findAndApplyWrapper;
